<ng-container>
    <ng-container *ngIf="ready">
        <div class="butonera">

        </div>

    </ng-container>

    <ng-container>
        <div class="tableTitle">
            <app-table [columns]="headerTable" [dataSource]="dataSource" [hasButton]="true" [hasSelect]="false"
                [actionsTemplate]="actionsButtons" [hasMonthFilter]="false" [hasHeaderActions]="false"
                [showTotals]="false" [showTotalsHasOptionToPay]="false">
            </app-table>
        </div>
    </ng-container>

    <ng-container *ngIf="spinner">
        <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
    </ng-container>

    <ng-template #actionsButtons let-uid="uid">
        <ng-container *ngFor="let row of (dataSource | filter : uid : 'uid'); trackBy: trackByIndex">
            <ul class="custom-class">
               <!--  <li (click)="edit(uid)" *ngIf="row.statusId != 3">

                    <a>
                        <mat-icon>create</mat-icon>Editar
                    </a>
                </li> -->
                <li (click)="update(uid, 1)" *ngIf="row.statusId != 1">

                    <a>
                        <mat-icon>save</mat-icon>Pendiente
                    </a>
                </li>
                <li (click)="update(uid, 2)" *ngIf="row.statusId != 2">
                    <a>
                        <mat-icon>save</mat-icon>En curso
                    </a>
                </li>
                <li (click)="update(uid, 3)" *ngIf="row.statusId != 3">
                    <a>
                        <mat-icon>save</mat-icon>Finalizada
                    </a>
                </li>
                <li (click)="pdf(uid)">
                    <a>
                        <mat-icon>dvr</mat-icon>PDF
                    </a>
                </li>
                <li (click)="assignInvoice(uid)">
                    <a>
                        <mat-icon>payment</mat-icon>Asignar factura
                    </a>
                </li>
            </ul>
        </ng-container>
    </ng-template>
</ng-container>
